import { GENERAL_URL_API } from "../urls";

export const fetchClientes = async (filtroActividad, tipoValue) => {
  const fd = new FormData();

  let show;
  Object.keys(filtroActividad).forEach((key) => {
    if (filtroActividad[key] === true) show = key;
  });

   
   
  fd.append("show", show);
  fd.append("tipoUsuario", tipoValue.tipo);
  const res = await fetch(`${GENERAL_URL_API}/verDatos/verClientes.php`, {
    method: "POST", credentials: 'include',
    body: fd,
  });
  return res.json();
};

/**
 * Clientes tipo Instituto que pertenecen a un Super Instituto.
 * @param {string} superInstituto
 * @returns {Promise<Array>} Clientes con `username`, `nombreCliente` e `institute`.
 */
export const fetchClientesPorSuperInstituto = async (superInstituto) => {
  const fd = new FormData();
  fd.append("show", "all");
  fd.append("tipoUsuario", "Instituto");
  fd.append("superInstituto", superInstituto);

  const res = await fetch(`${GENERAL_URL_API}/verDatos/verClientes.php`, {
    method: "POST",
    credentials: "include",
    body: fd,
  });
  const data = await res.json();

  return data?.data ?? [];
};
